import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-vehicle-road-tax.dto';
export * from './dtos/update-vehicle-road-tax.dto';
export * from './dtos/vehicle-road-tax-links.dto';
export * from './dtos/vehicle-road-tax-list.dto';
export * from './dtos/vehicle-road-tax-record.dto';
export * from './dtos/vehicle-road-tax-activity-event.dto';
export * from './dtos/vehicle-road-tax-activity-event-hydration.dto';
export * from './dtos/vehicle-road-tax-search.dto';
export * from './dtos/vehicle-road-taxes-stats.dto';

export * from './enums/vehicle-road-tax-record-category.enum';
export * from './enums/vehicle-road-tax-status.enum';
export * from './enums/vehicle-road-tax-action.enum';

export * from './functions/vehicle-road-tax-status-to-color.function';

export * from './types/vehicle-road-taxes-filters';

export * from './validators/schemas/create-vehicle-road-tax.schema';
export * from './validators/schemas/update-vehicle-road-tax.schema';

export const vehicleRoadTaxValidators = { canCreateOrUpdate, canPerformAction };
